import ImageUpload from './ImageUpload.js';
import Container from './editable/Container.js';
import notification from 'notification-js';
import Sortable from 'sortablejs';

export const mapping = ({data, path}) => {
  return {
    images: data.images
  }
}

export const transform = ({modal, path, updateState}) => {
  let carouselElement = getCarouselElement(path);

  return {
    images: {
      dom: '.editor-fields-gallery',
      callback: function() {
        let editorFields = modal.el.getElementsByClassName('editor-fields')[0];
        editorFields.__dirty = false;

        let imagesElement = modal.el.getElementsByClassName('image-edit');
        this.images.forEach((imageState, index) => {
          let imageElement = new Container({element: imagesElement[index],
                                            editable: true,
                                            data: this.images,
                                            index,
                                            updateState,
                                            onDelete: deleteImage});

          let image = imageElement.getField('image-preview');
          let imageUpload = imageElement.getField('image-upload');
          imageUpload.id = "gallery-image-" + index;

          image.onclick = (event) => {
            imageUpload.click();
          }

          imageElement.getElement().onclick = () => {
            $(carouselElement).slick('slickGoTo', index);
          }

          ImageUpload(imageUpload.id, image, onImageSave => {
            imageState.src = image.src;
            updateState();
          }, {ratio: "16:9", size: {minWidth: 400}});
        });

        var sortable = new Sortable(editorFields, {
        	group: "gallery",
        	sort: true,  // sorting inside list
        	delay: 0, // time in milliseconds to define when the sorting should start
        	animation: 150,  // ms, animation speed moving items when sorting, `0` — without animation
        	draggable: ".field-item-container",
        	scroll: true, // or HTMLElement
        	scrollSensitivity: 30, // px, how near the mouse must be to an edge to start scrolling.
        	scrollSpeed: 10, // px

        	// Called by any change to the list (add / update / remove)
        	onSort: function (evt) {

            this.images.splice(evt.oldIndex, 0, this.images.splice(evt.newIndex, 1)[0]);
            updateState();
        		// same properties as onUpdate
        	}.bind(this),

        });
      },
      transform: (image) => {
        let className = (image.src === "webAssets/images/upload.png") ? "image-preview upload-image"
                                                                   : "image-preview";
        return `
          <div class="field-item-container">
            <div class="slide image-edit max350">
              <img src="` + image.src + `" class="` + className + `" />
              <input type="file" class="image-upload" accept=".png,.jpeg,.jpg" style="display:none;"/>
              <a href="#" class="delete" style="display:none;">Delete</a>
            </div>
        </div>`;
      }
    }
  }
}

const getCarouselElement = (path) => {
  let carouselParentElement = document.querySelectorAll(
                              '[data-cms-render="' + path[path.length - 1] + '"]')[0];
  return carouselParentElement.getElementsByTagName('div')[0];
}

export const loadForm = ({modal, editor, data, path, updateState}) => {
  editor.slides = data.images;

  let addImageButton = modal.el.getElementsByClassName("addImage")[0];

  addImageButton.onclick = (event) => {
    addNewImage(event, modal, editor.images, updateState);
  }
};

export const getData = (currentState, editor) => {
  currentState.images = [];

  editor.images.forEach((image, index) => {
    let newImage = {};
    newImage.src = image.src;
    currentState.images.push(newImage);
  });

  return currentState;
}


const addNewImage = (event, modal, images, updateState) => {
  event.preventDefault();
  images.push({src: 'webAssets/images/upload.png'});
  let editorFields = modal.el.getElementsByClassName('editor-fields')[0];

  editorFields.scrollLeft = editorFields.offsetWidth;
  updateState();
}

const deleteImage = (event, images, index, updateState) => {
  event.preventDefault();
  if (images.length > 1) {
    images.splice(index, 1);
    updateState();
  } else {
    notification.notify( 'error', 'Unable to delete last image', {
      notification: {position: [ 'right', 'top' ]}
    });
  }
}

export default function() {
  let template = `
    <div class="form">
      <div class="editor-fields editor-fields-gallery">
      </div>
      <div class="field-item-container add-more">
        <div class="slide">
          <a href="#" class="addImage">+</a>
        </div>
      </div>
    </div>
  `

  return `<div>
    ${template}
  </div>`;
};



// WEBPACK FOOTER //
// ./src/editors/Gallery.js